// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3axUq","info":"info__27Mzy","name":"name__2HfxV","address":"address__3PCMq"};